import { render } from "./ImagesGestionComponent.vue?vue&type=template&id=7fa0aff2"
import script from "./ImagesGestionComponent.vue?vue&type=script&lang=js"
export * from "./ImagesGestionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__